import React, { useState, useContext } from "react";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";

import styles from "./NewNavbar.module.scss";

// components
import {
  Banner,
  CategorySlider,
  SearchInput,
  LocationSearch,
  SearchDropDown,
  Fragment,
  ProfileIcon,
  MenuDropDown,
} from "./components";
import Section from "../Section";
import Logo from "../Logo";
import { PreferenceModal } from "../Modal";
import Sidebar from "../Sidebar/Sidebar";
import Fab from "../Fab/Fab";

// assets
import { BurgerMenu, SearchIcon } from "src/assets/icons";
import { GrLocation } from "react-icons/gr";

// contex
import { UserAuthContext } from "src/context/UserAuthContext";

// import { temp_categories } from "./data";

const cx = classNames.bind(styles);

const NewNavbar = ({
  categories,
  activeCategory,
  handleCategoryChange,
  isDefault = true,
  isMobHide,
}) => {
  const { userLocation, updateUserLocation, user, logout } =
    useContext(UserAuthContext);

  const [showDD, setShowDD] = useState(false);
  const [searchEvents, setSearchEvents] = useState(null);

  const [showPrefModal, setShowPrefModal] = useState(false);
  const [showFragment, setShowFragment] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const handleDone = (_data) => {
    setShowDD(true);
    setSearchEvents(_data);
  };

  const handleClose = () => {
    setShowDD(false);
    setSearchEvents(null);
  };

  const toggleFragment = () => {
    setShowFragment(!showFragment);

    if (!showFragment) document.body.classList.add("set-y");
    else document.body.classList.remove("set-y");
  };

  const openSidebar = () => setShowSidebar(true);

  return (
    <div className={cx("new-navbar-root", { "mob-hidden": isMobHide })}>
      {!isDefault && (
        <Banner content="Enjoy the Eventmoon Experience observe the mask friendly events that follow the cdc guidelines" />
      )}
      <Section>
        <div className={cx("top-section")}>
          <div className={cx("left-side")}>
            <Logo wrapperClass={cx("logo-wrapper")} />
            <div className={cx("search-wrapper", "mob-hidden")}>
              <SearchInput
                isClose={showDD}
                userLocation={userLocation}
                handleDone={handleDone}
                handleClose={handleClose}
              />
              <SearchDropDown isOpen={showDD} data={searchEvents} />
            </div>
          </div>
          {/* {!isDefault && (
            <div className={cx("middle-side")} onClick={toggleFragment}>
              <GrLocation />
              <span>{userLocation?.name}</span>
            </div>
          )} */}
          <div className={cx("right-side")}>
            {!user ? (
              <Link to="/login">
                <button className={cx("login-btn")}>Login</button>
              </Link>
            ) : (
              <div style={{ position: "relative" }}>
                <ProfileIcon user={user} />
                <MenuDropDown handleLogout={logout} />
              </div>
            )}
            <div className={cx("mob-icon-wrapper")}>
              {/* <SearchIcon onClick={toggleFragment} /> */}
              <div className={cx("middle-side")} onClick={toggleFragment}>
                <GrLocation />
                <span>{userLocation?.name}</span>
              </div>
              <span className={cx("vr-line")} />
              <BurgerMenu onClick={openSidebar} />
            </div>
          </div>
        </div>
        {!isDefault && (
          <div className={cx("bottom-section")}>
            <CategorySlider
              data={categories}
              active={activeCategory}
              onChange={handleCategoryChange}
            />
            <LocationSearch
              wrapperClass={cx("mob-hidden")}
              userLocation={userLocation}
              updateUserLocation={updateUserLocation}
              setShowPref={setShowPrefModal}
            />
          </div>
        )}
      </Section>

      <PreferenceModal isOpen={showPrefModal} setIsOpen={setShowPrefModal} />
      <Fragment
        isOpen={showFragment}
        setShowPref={setShowPrefModal}
        toggle={toggleFragment}
      />
      <Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <Fab handleClick={toggleFragment} />
    </div>
  );
};

export default NewNavbar;
